import Vue from 'vue'
export const login = (state, payload) => {
  state.primaryPerson = payload
}
export const setSettings = (state, payload) => {
  state.settings = payload
}
export const setPersonGroups = (state, payload) => {
  state.personGroups = payload
}
export const setPersonGroup = (state, payload) => {
  state.proxyPerson.personGroupID = payload.personGroupID
}
export const updatePerson = (state, payload) => {
  if (state.proxyPerson) {
    state.proxyPerson = payload
  } else {
    state.primaryPerson = payload
  }
}
export const updatePersonNote = (state, payload) => {
  if (state.proxyPerson) {
    state.proxyPerson.note = payload
  } else {
    state.primaryPerson.note = payload
  }
}
export const setSearchResults = (state, payload) => {
  state.searchResults = payload
}
export const setProxyPerson = (state, payload) => {
  state.proxyPerson = payload
}
export const unloadProxyPerson = (state, payload) => {
  state.proxyPerson = false
}
export const setBaxterBucks = (state, payload) => {
  if (state.proxyPerson) {
    Vue.set(state.proxyPerson, 'baxterBucks', payload)
  } else {
    Vue.set(state.primaryPerson, 'baxterBucks', payload)
  }
}
export const setTimeout = (state, payload) => {
  state.timeout = payload
}
